import { createStyles } from "@material-ui/styles";

export const styles = createStyles(theme => ({
  root: {
    flexGrow: 1,
    minHeight: "100vh",
    backgroundColor: theme.kooee.backgrounds.default
  },
  paperClass: {
    backgroundColor: "transparent",
    boxShadow: "none",
    width: "96vw",
    marginBottom: "1vh",
    [theme.breakpoints.up("md")]: {
      width: "70vw"
    }
  },
  seperater: {
    // borderColor: theme.kooee.backgrounds.primary,
    height:"10px",
    // opacity:"0.0"
  }
}));
